import { useAuthStore } from '@/store/auth';
import { dashboardQueryIdentity } from '@/lib/salesDashboard';

export function useDashboardIdentity() {
  return useAuthStore(s => dashboardQueryIdentity(s.user));
}
